var exports = {
  "kL": "ChannelStickersArea.module__container___QVZFbH",
  "gI": "ChannelStickersArea.module__standalone___QVZFbH",
  "Qs": "ChannelStickersArea.module__content___QVZFbH",
  "UV": "ChannelStickersArea.module__stickerPreview___QVZFbH",
  "HF": "ChannelStickersArea.module__stickerImage___QVZFbH",
  "od": "ChannelStickersArea.module__stickerInfo___QVZFbH",
  "Zl": "ChannelStickersArea.module__stickerName___QVZFbH",
  "Gl": "ChannelStickersArea.module__stickerDescription___QVZFbH",
  "DT": "ChannelStickersArea.module__removeButton___QVZFbH",
  "Kk": "ChannelStickersArea.module__icon___QVZFbH",
};

module.exports = exports;
